const HeadingOne = ({ headOne, className }: { headOne: string; className?: string }) => {
    return (
        <h1
            className={`xl:text-[96px] lg:text-[80px] md:text-[65px] sm:text-[48px] text-[32px] font-extrabold dark:text-Grey20 text-bg-gray ${className}`}
        >
            {headOne}
        </h1>
    );
};

export default HeadingOne;
